export default {
  title: "Vyber organizaci",
  groupsTitle: "Vyber skupinu",
  goToFullOrganization: "Přejít na celou organizaci",
};
